import { DepositAndWithdrawType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const withdrawTypeName: { [key in DepositAndWithdrawType]: TKeyType } = {
  [DepositAndWithdrawType.SELF]: 'common.selfWithdraw',
  [DepositAndWithdrawType.THIRD_PARTY]: 'common.thirdWithdraw',
  [DepositAndWithdrawType.MANUAL]: 'page.manualWithdraw',
  [DepositAndWithdrawType.AGENT_TRANSFER_DEPOSIT]: 'agentWalletTransferType.deposit',
  [DepositAndWithdrawType.AGENT_WALLET]: 'withdraw.agent_transfer_withdraw'
}

export default withdrawTypeName
